import { render, staticRenderFns } from "./fund-list-dia.vue?vue&type=template&id=5adb32cb"
import script from "./fund-list-dia.vue?vue&type=script&lang=js"
export * from "./fund-list-dia.vue?vue&type=script&lang=js"
import style0 from "./fund-list-dia.vue?vue&type=style&index=0&id=5adb32cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports